// src/layouts/MainLayout.js
import React from 'react';
import Navbar from '../components/common/Navbar'; // パスが正しいか確認
import Footer from '../components/common/Footer'; // パスが正しいか確認

const MainLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main className="page-container">
        {children}
      </main>
      <Footer />
    </>
  );
};

export default MainLayout;